import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { FadeTextComponent } from '@shared/components/ellipsis-one-row/fade-text.component';
import { EColorPalette } from '@shared/enums/color-palette.enum';
import { EIcon } from '@shared/enums/icon.enum';
import { IconComponent } from '@ui-components/components/icon/icon.component';

import { InspectionTemplateServiceTaskOptionTypes } from '../../../interfaces/inspection-template-service-task-options.interface';

@Component({
  selector: 'app-cost-file-ticket-parts-setup-option',
  templateUrl: './cost-file-ticket-parts-setup-option.component.html',
  styleUrls: ['./cost-file-ticket-parts-setup-option.component.scss'],
  standalone: true,
  imports: [CommonModule, IconComponent, FadeTextComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostFileTicketPartsSetupOptionComponent {
  @Input() optionType: InspectionTemplateServiceTaskOptionTypes;
  @Input() settingsJson?: string | null;
  @Input() userCanEdit = false;
  @Input() selected = false;

  @Output() optionSelected = new EventEmitter<InspectionTemplateServiceTaskOptionTypes>();

  readonly EIcon = EIcon;
  readonly EColorPalette = EColorPalette;

  onSelect(): void {
    this.optionSelected.emit(this.optionType);
  }

  get label(): string {
    switch (this.optionType) {
      case InspectionTemplateServiceTaskOptionTypes.EstimatedCost:
        return 'Estimated cost';
      case InspectionTemplateServiceTaskOptionTypes.FileAsType:
        return 'Submit as';
      case InspectionTemplateServiceTaskOptionTypes.ResponsibleParty:
        return 'Responsibility';
      case InspectionTemplateServiceTaskOptionTypes.DueDate:
        return 'Due date';
      case InspectionTemplateServiceTaskOptionTypes.Assignee:
        return 'Assignee';
      case InspectionTemplateServiceTaskOptionTypes.SendToBoard:
        return 'Send to board';
      default:
        return '';
    }
  }

  get previewValue(): string {
    switch (this.optionType) {
      case InspectionTemplateServiceTaskOptionTypes.EstimatedCost:
        return '$';
      case InspectionTemplateServiceTaskOptionTypes.FileAsType:
        return 'Select';
      case InspectionTemplateServiceTaskOptionTypes.ResponsibleParty:
        return 'Select';
      case InspectionTemplateServiceTaskOptionTypes.DueDate:
        return 'Select';
      case InspectionTemplateServiceTaskOptionTypes.Assignee:
        return 'Select';
      case InspectionTemplateServiceTaskOptionTypes.SendToBoard:
        return 'Select';
      default:
        return 'Select';
    }
  }

  get icon(): EIcon {
    switch (this.optionType) {
      case InspectionTemplateServiceTaskOptionTypes.EstimatedCost:
        return EIcon.DOLLAR_MODERN;
      case InspectionTemplateServiceTaskOptionTypes.FileAsType:
        return EIcon.VENDOR_CHECK;
      case InspectionTemplateServiceTaskOptionTypes.ResponsibleParty:
        return EIcon.RESPONSIBLE_PARTY;
      case InspectionTemplateServiceTaskOptionTypes.DueDate:
        return EIcon.VENDOR_CALENDAR;
      case InspectionTemplateServiceTaskOptionTypes.Assignee:
        return EIcon.ASSIGNEE;
      case InspectionTemplateServiceTaskOptionTypes.SendToBoard:
        return EIcon.SEND_TO_BOARD;
      default:
        return EIcon.DOCUMENT_VALIDATION;
    }
  }

  get showAngle(): boolean {
    return this.optionType !== InspectionTemplateServiceTaskOptionTypes.EstimatedCost;
  }
}
